'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ZoomPanContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transformation = require('./Transformation');

var _Utils = require('./Utils');

var _ZoomPanModes = require('./ZoomPanModes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomPanContainer = exports.ZoomPanContainer = function (_Component) {
    _inherits(ZoomPanContainer, _Component);

    function ZoomPanContainer(props) {
        _classCallCheck(this, ZoomPanContainer);

        var _this = _possibleConstructorReturn(this, (ZoomPanContainer.__proto__ || Object.getPrototypeOf(ZoomPanContainer)).call(this, props));

        _this.updateTransformation = function (transformation) {
            if (!_this.controlled) {
                _this.setState({ transformation: transformation });
            }
            if (_this.props.onTransformationChange) {
                _this.props.onTransformationChange(transformation);
            }
        };

        _this.getTransformation = function () {
            return _this.controlled ? _this.props.transformation : _this.state.transformation;
        };

        _this.zoom = function (factor, clickX, clickY) {
            var transformation = _this.getTransformation().zoom(factor, clickX, clickY);
            _this.updateTransformation(transformation);
        };

        _this.zoomRectangle = function (x1, y1, x2, y2) {
            var transformation = _this.getTransformation().zoomRectangle(x1, y1, x2, y2, _this.props.width, _this.props.height);
            _this.updateTransformation(transformation);
        };

        _this.move = function (toX, toY) {
            var lastPt = _this.state.lastPt;


            var transformation = _this.getTransformation().move(lastPt.x, lastPt.y, toX, toY);
            _this.updateTransformation(transformation);
        };

        _this.moveDelta = function (deltaX, deltaY) {
            var transformation = _this.getTransformation().moveDelta(deltaX, deltaY);
            _this.updateTransformation(transformation);
        };

        _this.focus = function () {
            if (_this.container) {
                _this.container.focus();
            }
        };

        _this.reset = function (evt) {
            if (evt) {
                evt.preventDefault();
                evt.stopPropagation();
            }
            _this.updateTransformation(new _Transformation.Transformation());
        };

        _this.handleMouseDown = function (evt) {
            var mode = _this.props.mode;

            if (!mode) {
                return;
            }
            var transformation = _this.getTransformation();
            evt.preventDefault();
            var lastX = (0, _Utils.getMouseX)(evt);
            var lastY = (0, _Utils.getMouseY)(evt);
            var lastPt = { x: transformation.transformedX(lastX), y: transformation.transformedY(lastY) };
            _this.setState({
                dragStarted: true,
                lastX: lastX,
                lastY: lastY,
                lastPt: lastPt
            });
        };

        _this.handleMouseMove = function (evt) {
            var mode = _this.props.mode;

            if (!mode) {
                return;
            }
            if (mode === _ZoomPanModes.PAN && _this.state.dragStarted) {
                var x = (0, _Utils.getMouseX)(evt);
                var y = (0, _Utils.getMouseY)(evt);
                _this.move(x, y);
            }
        };

        _this.handleMouseUp = function (evt) {
            var _this$props = _this.props,
                mode = _this$props.mode,
                zoomFactor = _this$props.zoomFactor;

            if (!mode) {
                return;
            }
            var _this$state = _this.state,
                lastX = _this$state.lastX,
                lastY = _this$state.lastY;

            var x = (0, _Utils.getMouseX)(evt);
            var y = (0, _Utils.getMouseY)(evt);
            if (mode === _ZoomPanModes.ZOOMIN || mode === _ZoomPanModes.ZOOMOUT) {
                if (lastX !== x || lastY !== y) {
                    //Zoom drag
                    if (mode === _ZoomPanModes.ZOOMIN) {
                        _this.zoomRectangle(lastX, lastY, x, y);
                    } else {
                        // no rectangle zoom for zoom-out, just zomm out around the last click point
                        _this.zoom(1 / zoomFactor, lastX, lastY);
                    }
                } else {
                    //Zoom click
                    var factor = mode === _ZoomPanModes.ZOOMIN ? zoomFactor : 1 / zoomFactor;
                    _this.zoom(factor, x, y);
                }
            } else if (mode === _ZoomPanModes.PAN) {
                _this.move(x, y);
            }
            _this.setState({ dragStarted: false });
        };

        _this.handleMouseWheel = function (evt) {
            var _this$props2 = _this.props,
                continuousZoomWithControlKey = _this$props2.continuousZoomWithControlKey,
                zoomFactor = _this$props2.zoomFactor,
                reversePanScrollDirection = _this$props2.reversePanScrollDirection,
                moveSpeed = _this$props2.moveSpeed;

            evt.preventDefault();
            if (!continuousZoomWithControlKey || evt.ctrlKey) {
                var x = (0, _Utils.getMouseX)(evt);
                var y = (0, _Utils.getMouseY)(evt);
                _this.zoom(Math.pow(zoomFactor, -0.1 * evt.deltaY), x, y);
            } else {
                var direction = reversePanScrollDirection ? 1 : -1;
                _this.moveDelta(moveSpeed * direction * evt.deltaX, moveSpeed * direction * evt.deltaY);
            }
        };

        _this.handleKeyDown = function (evt) {
            var mode = _this.props.mode;

            if (!mode || mode !== _ZoomPanModes.ZOOMIN && mode !== _ZoomPanModes.ZOOMOUT && mode !== _ZoomPanModes.PAN) {
                return;
            }
            var _this$props3 = _this.props,
                keyDelta = _this$props3.keyDelta,
                shiftKeyFactor = _this$props3.shiftKeyFactor;

            var keyDeltaX = 0,
                keyDeltaY = 0,
                zoomDelta = 0;
            var moved = false;
            var zoomed = false;
            switch (evt.keyCode) {
                case 38:
                    /* Up arrow */
                    keyDeltaY = -keyDelta;
                    moved = true;
                    break;
                case 40:
                    /* Down arrow */
                    keyDeltaY = keyDelta;
                    moved = true;
                    break;
                case 37:
                    /* Left arrow */
                    keyDeltaX = -keyDelta;
                    moved = true;
                    break;
                case 39:
                    /* Right arrow */
                    keyDeltaX = keyDelta;
                    moved = true;
                    break;
                case 189: /* - */
                case 34:
                    /* Page down */
                    zoomDelta = keyDelta;
                    zoomed = true;
                    break;
                case 187: /* = */
                case 33:
                    /* Page up */
                    zoomDelta = -keyDelta;
                    zoomed = true;
                    break;
                default:
                    return;
            }
            evt.preventDefault();
            evt.stopPropagation();
            if (moved) {
                if (evt.shiftKey) {
                    keyDeltaX *= shiftKeyFactor;
                    keyDeltaY *= shiftKeyFactor;
                }
                _this.moveDelta(keyDeltaX, keyDeltaY);
            }
            if (zoomed) {
                var _this$props4 = _this.props,
                    zoomFactor = _this$props4.zoomFactor,
                    width = _this$props4.width,
                    height = _this$props4.height;

                if (evt.shiftKey) {
                    zoomDelta *= shiftKeyFactor;
                }
                _this.zoom(Math.pow(zoomFactor, -0.1 * zoomDelta), width / 2, height / 2);
            }
        };

        _this.state = {
            dragStarted: false,
            lastX: 0,
            lastY: 0
        };
        _this.controlled = Boolean(props.transformation);
        if (!_this.controlled) {
            _this.state.transformation = new _Transformation.Transformation();
        }
        return _this;
    }

    _createClass(ZoomPanContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.transformation && !nextProps.transformation) {
                console.warn("Component is changing from controlled to uncontrolled");
            }
        }

        /**
         * Zoom by the given factor around the point (clickX, clickY).
         * This means that the point (clickX, clickY) stays in the same position after the zoom
         *
         * @param factor
         * @param clickX
         * @param clickY
         */


        /**
         * Zoom around the center of the dragged rectangle.
         *
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                width = _props.width,
                height = _props.height,
                style = _props.style,
                zoomFactor = _props.zoomFactor,
                mode = _props.mode,
                moveSpeed = _props.moveSpeed,
                keyDelta = _props.keyDelta,
                shiftKeyFactor = _props.shiftKeyFactor,
                initialTransformation = _props.initialTransformation,
                continuousZoomWithControlKey = _props.continuousZoomWithControlKey,
                reversePanScrollDirection = _props.reversePanScrollDirection,
                allowFocus = _props.allowFocus,
                children = _props.children,
                onTransformationChange = _props.onTransformationChange,
                transformation = _props.transformation,
                className = _props.className,
                containerProps = _objectWithoutProperties(_props, ['width', 'height', 'style', 'zoomFactor', 'mode', 'moveSpeed', 'keyDelta', 'shiftKeyFactor', 'initialTransformation', 'continuousZoomWithControlKey', 'reversePanScrollDirection', 'allowFocus', 'children', 'onTransformationChange', 'transformation', 'className']);

            var dragStarted = this.state.dragStarted;

            var focusProps = allowFocus ? { ref: function ref(c) {
                    return _this2.container = c;
                }, tabIndex: 0 } : {};
            return _react2.default.createElement(
                'div',
                _extends({}, focusProps, {
                    onMouseDown: mode ? this.handleMouseDown : undefined,
                    onTouchStart: mode ? this.handleMouseDown : undefined,
                    onMouseMove: mode ? this.handleMouseMove : undefined,
                    onTouchMove: mode ? this.handleMouseMove : undefined,
                    onMouseUp: mode ? this.handleMouseUp : undefined,
                    onTouchEnd: mode ? this.handleMouseUp : undefined,
                    onWheel: this.handleMouseWheel,
                    onKeyDown: mode ? this.handleKeyDown : undefined,
                    style: _extends({}, style, { width: width, height: height }), className: (className ? className : '') + ' ' + (mode ? mode.toLowerCase() : '') + (dragStarted ? ' mouse-down' : '') }, containerProps),

                // using the " Children-as-Function" pattern: https://medium.com/merrickchristensen/function-as-child-components-5f3920a9ace9
                typeof children === 'function' ? children(initialTransformation.combine(this.getTransformation())) : children
            );
        }
    }]);

    return ZoomPanContainer;
}(_react.Component);

ZoomPanContainer.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.func, // using the "Children-as-Function" pattern: https://medium.com/merrickchristensen/function-as-child-components-5f3920a9ace9
    _propTypes2.default.node] // regular children
    ).isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    initialTransformation: _propTypes2.default.instanceOf(_Transformation.Transformation),
    transformation: _propTypes2.default.instanceOf(_Transformation.Transformation), // if provided, this component becomes controlled
    onTransformationChange: _propTypes2.default.func,
    zoomFactor: _propTypes2.default.number,
    mode: _propTypes2.default.string,
    continuousZoomWithControlKey: _propTypes2.default.bool,
    reversePanScrollDirection: _propTypes2.default.bool,
    moveSpeed: _propTypes2.default.number,
    keyDelta: _propTypes2.default.number,
    shiftKeyFactor: _propTypes2.default.number,
    allowFocus: _propTypes2.default.bool
};
ZoomPanContainer.defaultProps = {
    initialTransformation: new _Transformation.Transformation(),
    zoomFactor: 1.1,
    continuousZoomWithControlKey: true,
    reversePanScrollDirection: false,
    moveSpeed: 1.0,
    keyDelta: 5,
    shiftKeyFactor: 5,
    allowFocus: true
};


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/ZoomPanContainer.js
// module id = 1217
// module chunks = 0